import * as React from 'react';
var FormContext = /*#__PURE__*/React.createContext({
  labelAlign: 'right',
  vertical: false
});
export default FormContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ant-design/compatible/es/form/context.js
// module id = 1256
// module chunks = 1